<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("btn.qualityData.review") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('btn.qualityPlan.result')}}</span></router-link></li> -->
          <li class="breadcrumb-item">
            <span>{{$t('btn.qualityData.review')}}</span>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.planCode")}}</label>
                  <input class="form-control" type="text" v-model.trim="planCodeFilter" />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.sentTime")}}</label>
                  <mmf-datepicker v-model="sentTimeFilter"></mmf-datepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.planDate")}}</label>
                  <mmf-datepicker v-model="planDateStrFilter"></mmf-datepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.shift")}}</label>
                  <select class="form-control" type="text" v-model="shiftFilter">
                    <option value="甲">{{ $t("lbl.shift.A") }}</option>
                    <option value="乙">{{ $t("lbl.shift.B") }}</option>
                    <option value="丙">{{ $t("lbl.shift.C") }}</option>
                  </select>                  
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.itemName")}}</label>
                  <dimsearch
                    name="itemName"
                    v-model="itemNameFilter"
                    :entity="qualityItems"
                    bindId="itemNameFilter"
                    bindProp="itemName"
                    submitProp="itemName"
                  ></dimsearch>
                </div>
                <!-- <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.itemName")}}</label>
                  <input class="form-control" type="text" v-model="itemNameFilter" />
                </div> -->

                <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="MMFClearFilter('qualityData')"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button class="btn btn-primary" type="button" v-on:click="loadRows()">
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="qualityDataTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="qualityData"
                inline-actions-disabled
                disableEdit
                disableDelete
                :singleChoice="true"
              >
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <b-button
                    v-b-modal.modal-1
                    variant="outline-primary"
                    :disabled="slotProps.checkedLength!=1"
                  >
                    <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                    <span class="text">{{$t('btn.qualityData.review')}}</span>
                  </b-button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal
      id="modal-1"
      :title="$t(title)"
      @ok="jumpToQualityCheck(entity)"
      :ok-title="$t('btn.system.ok')"
      :cancel-title="$t('btn.system.cancel')"
    >
      <b-container>
        <h4>{{$t(messageCheck)}}?</h4>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/qualityMgt/pelletizing/QualityData";
import { fields } from "@/model/prd/qualityMgt/pelletizing/QualityData";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";
import dimsearch from "@/components/MMFDimSearch";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityData/getField",
  mutationType: "qualityData/updateField"
});

export default {
  name: "qualityDataList",
  data() {
    return {
      title: "btn.qualityData.review",
      messageCheck: "tlt.qualityReview.isReview",
    };
    
  },
  components: { MmfTable, MmfDatepicker,dimsearch },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.qualityData.rows,
      qualityItems: state => state.qualityData.itemCode,
      tableColumns: gridFields,
      entity: state => state.qualityData.entity,
      checkedItems: state => state.qualityData.checkedItems,
      baseModuleUrl: state => state.qualityData.baseModuleUrl,
      qualityPlanStatus: state => state.qualityData.qualityPlanStatus
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter"]),

    ...mapActions("qualityData", ["jumpToQualityCheck","selectItem"]),



    loadRows() {
      this.statusFilter = "C";
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let day = date.getDate();
      if(month<10){
          month = "0" + month
      }
      if(day < 10){
          day = "0" + day
      }
      this.planDateStrFilter = year + '-' + month + '-' + day;
      this.MMFLoadRows("qualityData");
    }
  },
  mounted() {
    //自动加载页面 this.MMFLoadRows("rawMaterial");
    this.$store
      .dispatch(
        "api/get",
        {
          url: this.$store.state.qualityItem.baseModuleUrl + "/qualityItem/findAll"
        },
        {
          root: true
        }
      )
      .then(data => {
        data.push({});
        this.$store.commit("qualityData/setItemCode",data) 
      });
      this.loadRows();
  }
};
</script>
